mutation CompanyUpdate($input: CompanyUpdateInput!) {
  companyUpdate(input: $input) {
   approvalPhaseType
   {phaseName}
  }
}